import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type PortfolioSmartInsightsService from 'lumen/services/portfolio-smart-insights';

export default class MarketSmartInsightsRoute extends Route {
  queryParams = {
    groupBy: {
      refreshModel: false,
    },
    priorities: {
      refreshModel: false,
    },
    smartInsightsTab: {
      refreshModel: false,
    },
    sortBy: {
      refreshModel: false,
    },
  };

  @service declare access: Services['access'];
  @service declare portfolioSmartInsights: Services['portfolio-smart-insights'];

  @service('transition') declare transitionService: Services['transition'];

  beforeModel(): void {
    if (!this.access.hasSmartInsights) {
      this.transitionService.redirectToEnabledTab();
    }
  }

  deactivate(): void {
    // Cancel all running API tasks when navigating away from Smart Insights
    // to prevent background requests from continuing unnecessarily.
    this.portfolioSmartInsights.cancelAllTasks();
  }

  model(): {
    myHotels: PortfolioSmartInsightsService['getMyHotelsTask'];
    smartInsights: PortfolioSmartInsightsService['getHotelSmartInsightsTask'];
  } {
    const model = {
      myHotels: this.portfolioSmartInsights.getMyHotelsTask,
      smartInsights: this.portfolioSmartInsights.getHotelSmartInsightsTask,
    };

    // Always fetch the hotels since the user might have changed which hotels they can access in the hotel access settings.
    // The smart insights will be fetched only for the hotels that are selected to be displayed.
    void model.myHotels.perform();

    return model;
  }
}
